import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'vuetify/src/stylus/app.styl';
import AppPage from '../components/AppPage.vue';
import { VUETIFY_TRANSLATIONS_NAMESPACE } from './i18next';

// No sv translations shipped with Vuetify - need to use own ones
export function initializeVuetify(i18nInstance) {
  Vue.use(Vuetify, {
    iconfont: 'md',
    theme: {
      primary: '#424960',
    },
    lang: {
      t: (key, ...params) => {
        return i18nInstance.t(`${VUETIFY_TRANSLATIONS_NAMESPACE}:${key}`, params);
      },
    },
  });

  Vue.component('app-page', AppPage);
}
